import React from 'react';
import { connect } from 'react-redux';

import { Button, Form } from 'components';

import { resetPassword } from 'redux/reducers/user';

import styles from './styles.scss';

@connect(
  state => ({
    failedPasswordReset: state.getIn(['user', 'failedPasswordReset'], false),
  }),
  {
    resetPassword,
  }
)
export default class ResetPassword extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      password: null,
    };
  }

  resetPassword = e => {
    e.preventDefault();
    const { password } = this.state;
    const { user_id, token } = this.props.match.params;

    this.props.resetPassword(user_id, token, password);
  };

  onChange = e => {
    const input = e.currentTarget;

    this.setState({
      [input.name]: input.type === 'checkbox' ? input.checked : input.value,
    });
  };

  render() {
    const { password } = this.state;
    const { failedPasswordReset } = this.props;

    return (
      <div className={styles.reset}>
        <form method="POST" onSubmit={this.resetPassword}>
          <Form.Row>
            <Form.Input
              name="password"
              type="password"
              label={kroostApp.strings.newPasswordLabel}
              placeholder={kroostApp.strings.newPasswordPlaceholder}
              onChange={this.onChange}
            />
          </Form.Row>

          {failedPasswordReset ? <Form.Error>{kroostApp.strings.formErrorMessage}</Form.Error> : null}

          <Form.Row>
            <Button type="submit" disabled={!password} onClick={this.resetPassword}>
              {kroostApp.strings.passwordButtonSubmit}
            </Button>
          </Form.Row>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/reset-password/index.js